<template>
  <div id="app">
    <router-view v-if="!$route.meta.cache"/>
    <keep-alive>
      <router-view v-if="$route.meta.cache"/>
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  html,body{
    height: 100%;
    background: #f5f5f5;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
    height: 100%;

    &>div{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  .slide-right-enter-active, .slide-right-leave-active {
    transition: all .4s;
  }

  .slide-right-enter, .slide-right-leave-active {
    transform: translate3d(100%, 0, 0);
  }

  .van-tabs__line {
    background: #5788e4;
  }

  .van-nav-bar {
    background: #5788e4 !important;
    color: #fff;

    .van-nav-bar__title {
      color: #fff;
      font-weight: bold;
      font-size: 18px;
    }

    .van-icon,.van-nav-bar__text {
      color: #fff !important;
    }
  }

  .van-swipe-cell__right .van-button{
    height: 100%;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0;
  }

  .bottom_box{
    height: 60px;

    .btn_box{
      position: fixed;
      left: 0;
      bottom: 0;
      background: #fff;
      width: 100%;
      border-top: 1px solid #f4f4f4;
      box-sizing: border-box;

      .btn{
        flex: 1;
        font-size: 13px;
        height: 50px;
        position: relative;
        padding: 0 15px;
      }
    }
  }

  .mask_box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    z-index: 99;
  }

  .van-tabs--line .van-tabs__wrap{
    height: 46px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue